<div class="comparables-host">
  <side-bar-navigation class="side-bar-navigation"></side-bar-navigation>
  <div id="comparablesModule" class="areaModuleContainer" ng-keydown="onKeyPressed($event)">
    <div class="areaModuleContainerInner">

      <div class="vpSearchForm" id="comparables-searchbar" [style.width.px]="paneWidths['#comparables-searchbar']" *ngIf="showSearchBar">
        <property-search-form mode="'comparables'" *ngIf="searchTabVisible && searchTab === 'comparablesProperty'"></property-search-form>
        <comparables-lease-search mode="'comparables'" *ngIf="searchTabVisible && searchTab === 'comparablesLease'" [selectedItem]="selectedTabHierarchyItem" [selectedItemType]="selectedTabHierarchyItemType"></comparables-lease-search>
        <valuations-search-form mode="'comparables'" *ngIf="searchTabVisible && searchTab  === 'comparablesValuation'" [selectedItem]="selectedTabHierarchyItem" [selectedDesc]="selectedPropertyDescription" [selectedItemType]="selectedTabHierarchyItemType"></valuations-search-form>
      </div>

      <div class="polluxPane polluxWorkplacePane">
        <comparables-workplace [main]="this" class="pollux-workplace"></comparables-workplace>
      </div>

      <div id="comparables-infobar" class="infobar" [style.width.px]="infobarWidth" [hidden]="!infoBarVisibility">
        <comparables-infobar [main]="this"></comparables-infobar>
      </div>
    </div>
  </div>

  <app-confirm-dialog></app-confirm-dialog>
  <app-import-dialog></app-import-dialog>
  <confirm-delete-dialog></confirm-delete-dialog>
</div>
